import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { TextField, TextFieldStyle, TextFieldWidth } from "azure-devops-ui/TextField";

const inlineObservable = new ObservableValue<string>("");

export default class InlineTextFieldExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <TextField
                prefixIconProps={{ iconName: "Search" }}
                value={inlineObservable}
                onChange={(e, newValue) => (inlineObservable.value = newValue)}
                placeholder="Search items"
                style={TextFieldStyle.inline}
                width={TextFieldWidth.standard}
            />
        );
    }
}
